/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
 
require('./bootstrap');
require('owl.carousel');
require('owl.carousel/dist/assets/owl.carousel.css');
require('jquery-mask-plugin');

$(function () {
	/*/
	 *  ...
	/*/

	/*$('#allworkandnoplaymakesjackadullboy').click(function() {	
		$('#redrum').fadeOut(750);
	});

	$(document).keyup(function(e) {
		if (e.keyCode == 27) {
			$('#redrum').fadeOut(750);
		}
  	});*/


	/*/
	 *  Scroll reveal
	/*/
		const ScrollReveal = require('scrollreveal')({
			distance: '75px',
			scale: 1,
			duration: 1000,
			reset: false,
			mobile: true,
			viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
			beforeReveal: function (domEl) {
		    	$(domEl).addClass('is-visible');
		    }
		});

		// default values
		ScrollReveal.reveal('.right-scrollreveal', { origin: 'right' });
		ScrollReveal.reveal('.left-scrollreveal', { origin: 'left' });
		ScrollReveal.reveal('.top-scrollreveal', { origin: 'top' });
		ScrollReveal.reveal('.bottom-scrollreveal', { origin: 'bottom' });

		// sequenced values
		ScrollReveal.reveal('.bottom-groupreveal > *', { duration: 1000, origin: 'bottom' }, 50);
		ScrollReveal.reveal('.left-groupreveal > *', { duration: 1000, origin: 'left' }, 50);

	/*/
	 *  Carousel
	/*/
		var showNav = $('#owl-index .media-responsive').length > 1 ? true : false;
		$(document).ready(function(){
			$('#owl-index').owlCarousel({
				loop: showNav,
				autoplay: true,
				autoplayTimeout: 5000,
				autoPlaySpeed: 5000,
				autoplayHoverPause: true,
				items: 1,
				nav: false,
				dots: showNav,
			});
		});

		$(document).ready(function(){
			$('#history-nav').owlCarousel({
				loop: false,
				autoplay: false,
				autoPlaySpeed: 5000,
				nav: true,
				dots: false,
				responsive : {
				    0 : {
				        items: 2,
				        margin: 20
				    },
				    568 : {
				        items: 3,
				        margin: 20
				    },
				    768 : {
				        items: 3,
				        margin: 40
				    },
				    992 : {
				        items: 4,
				        margin: 40
				    },
				    1200 : {
				        items: 5,
				        margin: 40
				    },
				}
			});
		});


	/*/
	 *  Nav de História
	/*/
		$('#history-nav a[data-toggle="tab"]').on('show.bs.tab', function (e) {
		  e.target // newly activated tab
		  e.relatedTarget // previous active tab

		  $(this).parent().parent().find('.in').removeClass('in');
		  $(this).addClass('in');
		});

	/*/
	 *  Modal
	/*/
		// [change between modals] 
			$('.add-product').click(function(){
				var id = $(this).attr('data-id');
				var routeAdd = $(this).attr('data-route');
				var routeBudget = $(this).attr('data-route-budget');

				$('#modal-produto-' + id).modal('hide');

				window.axios.post(routeAdd, {product_id : id})
				.then(response => {


						$('#modal-orcamento').modal('show');
						setTimeout(function () {
							$('body').addClass('modal-open');
						}, 350);
					})

				.catch(error => {
					alert('erro, tente novamente.');
				});

				
				
			});


			function loadProductsBudgets(route = null)
			{
				if(!route) {
					var route = $('#budget').attr('data-route-budget');
				}

				window.axios.get(route)
				.then(response => {
					 
					 $('#budget').empty();
					 $('#message-no-products').remove();


					$.each(response.data, function(key, response) {
						var html = '<li><span>'+ response.category +' - '+ response.code +'</span>';

							html += '<div class="dropdown"><button type="button" data-toggle="dropdown"><i></i><span class="sr-only">Remover</span></button>';

							html += '<div class="dropdown-menu"><span>Deseja realmente excluir este item?</span><a href="javascript:void(0);" class="btn btn-default-3">Não</a><a href="javascript:void(0);" class="btn btn-default-1" onclick="budgetControls.remove('+ key +')">Sim</a></div></div></li>';

							$('#budget').append(html);

					});

					if(response.data.length == 0) {
					 	$('#budget').parent().append('<p id="message-no-products">Nenhum produto foi adicionado ao orçamento.</p>');
					 }

					checkCart();
				})
				.catch(error => {
					console.log(error);
					console.log('erro, tente novamente.');
				});
			}

			function checkCart(){

				if($('#budget li').length == 0) {
					$('.tab2-link').prop("disabled",true);
				}else {
					$('.tab2-link').prop("disabled",false);
				}
			}

		// [hidden navigation] 
			$('.tab1-link').click(function(){
				$('#tab1-hidden').click();
			});
			$('.tab2-link').click(function(){
				$('#tab2-hidden').click();
			});
			$('.tab3-link').click(function(){				
				$('#tab3-hidden').click();
			});


		// [force open on tab1] 
			$('#modal-orcamento').on('show.bs.modal', function (e) {
				loadProductsBudgets();
				$('#tab1-hidden').click();
			});

		// [autoclose on show tab3]
			$('#tab3-hidden[data-toggle="tab"]').on('shown.bs.tab', function (e) {
				e.target;
				setTimeout(function () {
					$('#modal-orcamento').modal('hide');
				}, 15000);
			});

	/*/
	 *  Nav controls [theme-color - scrolltop - basic controls]
	/*/
		$('.control-toggle-open').click(function(){
			$('body').addClass('nav-open');
			$("meta[name='theme-color']").attr('content', '#418927');
			if ($(window).width() > 767) {
				$('html, body').animate({scrollTop: $("#app").offset().top}, 500);
			}
		});
		$('.control-toggle-dismiss').click(function(){
			$('body').removeClass('nav-open');
			$('header nav').animate({scrollTop: 0 }, 100);
			$("meta[name='theme-color']").attr('content', '#ffffff');
		});
		$(document).keyup(function(e) {
		     if (e.keyCode == 27) {
		        $('body').removeClass('nav-open');
				$('header nav').animate({scrollTop: 0 }, 100);
				$("meta[name='theme-color']").attr('content', '#ffffff');
		    }
		});

	/*/
	 *  Input file
	/*/
		$( 'input[type="file"]' ).change( function () {
		  	let label_name = $( this ).parent().find( '.file-name' );
		  	if ( !this.files.length ) {
		  		label_name.text( 'Selecione um arquivo' );
		  	} else if ( this.files.length === 1 ) {
				label_name.text( `${this.files[ 0 ].name}` );
			} else {
				label_name.text( `${this.files.length} arquivos selecionados` );
			}
		});

	/*/
	 *  Scroll animate on collapse
	/*/
		$('#collapse-vagas').on('show.bs.collapse', function () {
			$('html, body').animate({scrollTop: $("#vagas-anchor").offset().top}, 500);
		});

	    $('.panel-collapse').on('shown.bs.collapse', function (e) {
		    var $panel = $(this).closest('.panel');
		    if ($(window).width() > 767) {
		    	$('html, body').animate({ scrollTop: $panel.offset().top - 120}, 500); 
			} else {
		    	$('html, body').animate({ scrollTop: $panel.offset().top - 111}, 500); 
			}		    
		});

	    /*$('.group-year').on('shown.bs.collapse', function (e) {
		    var $panel = $(this);
		    if ($(window).width() > 767) {
		    	$('html, body').animate({ scrollTop: $panel.offset().top - 97}, 500); 
			} else {
		    	$('html, body').animate({ scrollTop: $panel.offset().top - 144}, 500); 
			}		    
		});*/

	/*/
	 *  Forms
	/*/

	var options = {
	    onKeyPress: function (cpf, ev, el, op) {
	        var masks = ['000.000.000-000', '00.000.000/0000-00'],
	            mask = (cpf.length > 14) ? masks[1] : masks[0];
	        el.mask(mask, op);
	    }
	}

	$('#cpfcnpj').mask('000.000.000-000', options);

	$('#cnpj').mask('00.000.000/0000-00');

	$('input[type="tel"]')
        .mask("(99) 99999-9999");

	const formSubmit = $(".on-form-submit");

	formSubmit.submit(function (event) {
		event.preventDefault();
		$('.button-submit').text('Enviando');
		$('.button-submit').prop('disabled', true);

		const form = $(this);

		if ($('.cf-turnstile').length > 0) {
			const token = $('input[name="cf-turnstile-response"]').val();

			axios.post('/siteverify', {
				response: token
			},
			)
			.then(function (response) {
				form.off('submit').submit();
			})
			.catch(function (error) {
				console.log(error)
			})
		}
	});

	const form = $("#formCart");

	form.submit(function (event) {
	event.preventDefault();

	const button = form.find('[type="submit"]');
	var originalText = button.text();

	button.attr('disabled', true).text('enviando...');

	window.axios.post(this.action, $(this).serialize())
		.then(response => {
			form[0].reset();

			$('[name="formCart"] input, [name="formCart"] textarea').trigger('keydown');
			loadProductsBudgets();

			$('#tab3-hidden').click();

		})
		.catch(error => {
			button.text('erro, tente novamente.');
			setTimeout(function () {
				button.attr('disabled', false).text(originalText);
			}, 4000);
		})
	});	



	const formNews = $("#formNews");

	formNews.submit(function (event) {
	event.preventDefault();

	const button = formNews.find('[type="submit"]');
	var originalText = button.text();

	button.attr('disabled', true).text('enviando...');

	window.axios.post(this.action, $(this).serialize())
		.then(response => {
			formNews[0].reset();
			
			button.text('Enviado!');

			$('[name="formNews"] input, [name="formNews"] textarea').trigger('keydown');

			$('#modal-newsletter').modal('show');

			setTimeout(function () {
				button.attr('disabled', false).text(originalText);
			}, 4000);

		})
		.catch(error => {
			button.text('erro, tente novamente.');
			setTimeout(function () {
				button.attr('disabled', false).text(originalText);
			}, 4000);
		})
	});	


	var budgetControls = (function () {
		return {
			remove: function(index){
				var routeRemove = $('#budget').attr('data-route-remove');
				var route = routeRemove + '?index='+index;

				window.axios.get(route)
					.then(response => {
						 loadProductsBudgets()
					});

					},
				}
	}());
		

	window.budgetControls = budgetControls;	


	 $('.image-thumb-video').click(function() {
    	var url = $(this).attr('data-url');
    	var id = $(this).attr('data-id');
  
    	var element = $('#video-' + id);

    	var html = '<iframe width="800" allowfullscreen height="600" class="embed-video-' + id + '" frameborder="false" src="'+ url +'"></iframe>';
    	element.append(html);

		$(this).hide();
		$('.embed-video-' + id).show();
	});

	 $('select[name="subject"]').on('change', function (e){

 		$('.opt').each(function( index ) {
			$( this ).prop('placeholder', $( this ).attr('placeholder').replace(' (opcional)', ''));  
			$( this ).prop('required', true);
		});


	 	if($('select[name="subject"] option:selected').attr('data-opt') == 'true') {
	 		$('.opt').each(function( index ) {
					$( this ).prop('placeholder', $( this ).attr('placeholder') + ' (opcional)' );		  
					$( this ).prop('required', false);
			});
		}

	 });


});

/*
 * LGPD Popup
*/
const siteLGPD = document.querySelector('.lgpd')

if (siteLGPD) {
	const siteLGPDCheck = localStorage.getItem('lgpd_terms_accepted')
	const siteLGPDDismiss = siteLGPD.querySelector('#lgpd-accept')

	window.addEventListener('load', _ => {
		setTimeout(() => {
			if (!siteLGPDCheck) {
				siteLGPD.classList.add('is--visible')
				siteLGPDDismiss.focus()
			} else {
				siteLGPD.remove();
			}
		}, 3000)
	})

	siteLGPDDismiss.addEventListener('click', _ => {
		siteLGPD.classList.remove('is--visible')
		localStorage.setItem('lgpd_terms_accepted', true)

		setTimeout(function () {
			siteLGPD.remove()
		}, 1000)
	})
}
